import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';

import Heading from '../Heading';
import Paragraph from '../Paragraph';

let styles;

export default class PromoSearch extends Component {
  render() {
    return (
      <div className={css(styles.container)}>
        <Heading styles={styles.heading}>Find your new best friend</Heading>
        {Theme.isMobile ?
          <Paragraph>Join us to view their full profiles, and see more dogs!</Paragraph>
        : null}
      </div>
    );
  }
}

styles = StyleSheet.create({
  container: {
    paddingTop: 40,
    paddingBottom: 40,
    fontFamily: Theme.font_family_primary,
    fontSize: Theme.font_size_primary,
    fontWeight: Theme.font_weight_primary,
    textAlign: 'center',
    backgroundColor: '#fff',

    [Theme.mobile_query]: {
      padding: '40px 20px',
    },
  },
  heading: {
    fontSize: 30,

    ':not(:last-child)': {
      marginBottom: 16,
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/PromoSearch/index.js